module.exports = __webpack_public_path__ + "img/img-2.3bc953f7.png";